var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "19px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 28 5 L 13 57 L 16 57 L 25.273438 48.804688 L 22 60 L 25 60 L 53.515625 33.796875 L 40 8 L 37 8 L 35.328125 13.580078 L 31 5 L 28 5 z M 29.826172 10.082031 L 40.771484 31.103516 L 18.195312 51.087891 L 29.826172 10.082031 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpiIcon);
export default __webpack_public_path__ + "static/media/upi-icon.ab0fe8ad6b57fdc8e96b9a76a8eae2d3.svg";
export { ForwardRef as ReactComponent };